module.exports = __webpack_public_path__ + "img/logo_sesepa.5985b534.jpg";